// extracted by mini-css-extract-plugin
export var acitonButtons = "_cb-0";
export var additionalIcon = "_cb-f";
export var block = "_cb-1";
export var blockContent = "_cb-7";
export var blockDescription = "_cb-8";
export var blockIcon = "_cb-9";
export var blockTitle = "_cb-6";
export var border = "_cb-a";
export var center = "_cb-l";
export var edge = "_cb-b";
export var edgeLabel = "_cb-c";
export var edgePath = "_cb-d";
export var error = "_cb-e";
export var flowchart = "_cb-g";
export var flowchartContent = "_cb-h";
export var highlighted = "_cb-3";
export var hover = "_cb-4";
export var icon = "_cb-i";
export var left = "_cb-m";
export var navButton = "_cb-j";
export var navButtons = "_cb-k";
export var right = "_cb-n";
export var selected = "_cb-2";
export var small = "_cb-5";